import TImer from '@assets/svgs/auth/otp-timer-icon.svg';
import AuthLayout from '../components/auth/authLayout';
import OtpInput from '../components/auth/otpInputs';
import { Trans } from 'react-i18next';
import { formatOtpTime } from '@/utils/helpers';
import { useOtpPage } from '@/hooks/useOtpPage';
import BackButton from '@/components/shared/backButton';
import tw from 'twin.macro';

const OtpPage = () => {
  const {
    setOtpLastValue,
    errorMessage,
    isFalseValue,
    isTrueValue,
    isReset,
    timeLeft,
    isPending,
    canResendOtp,
    handleResendOtp,
    navigate,
  } = useOtpPage();

  return (
    <>
      <AuthLayout
        customContainerStyle={tw`space-y-6 xl:w-[65%] lg:w-[75%] md:w-[90%] sm:w-[90%] w-[100%] pb-8`}
        aboveTitle={
          <BackButton
            handelClick={() => {
              navigate('/login', { replace: true });
            }}
          />
        }
        authSection={
          <>
            <OtpInput
              readOnly={isPending}
              isFalseValue={isFalseValue}
              isTrueValue={isTrueValue}
              setOtpLastValue={setOtpLastValue}
              iseReset={isReset}
              errorMessage={errorMessage}
            />
            <div
              css={[
                tw`flex justify-between items-center w-full !mt-[1rem] px-[0.75rem] pb-6 min-h-[3rem]`,
                tw`max-md:px-[0rem] max-md:!mt-[1.5rem]`,
              ]}
            >
              <span tw="font-[500] text-[.875rem] font-['Inter']">
                didn't receive the code?{' '}
                <span
                  onClick={canResendOtp ? handleResendOtp : undefined}
                  css={
                    canResendOtp ? tw`text-info` : tw`text-text_primary opacity-50 cursor-default`
                  }
                  tw="font-bold cursor-pointer"
                >
                  Resend now!
                </span>
              </span>
              <p tw="text-[.8125rem] font-['Inter'] flex items-center gap-1 font-semibold">
                <img loading="lazy" decoding="async" tw="w-[1.1875rem] font-['Inter'] h-[1.1875rem]" src={TImer} alt="Timer" />
                {formatOtpTime(timeLeft)}
              </p>
            </div>
          </>
        }
        isLogIn
        hasOpacity={false}
        subtitle={
          <span tw="text-text_primary font-normal opacity-50 max-md:text-[0.9375rem]">
            To secure your account, we emailed you the six digit code to enter below.{' '}
          </span>
        }
        title={'Verify otp'}
      />
    </>
  );
};

export default OtpPage;
